/**
 *  Funcion que hace una copia de un objeto
 * @param {object} obj
 */
export function copyObject(obj){
    if(!obj) return {};
    return JSON.parse(JSON.stringify(obj));
  }